import React from 'react'

const PartnersCTA = () => (
  <div className='partners-cta-container'>
    <div className='partners-cta white pt-5 pb-5'>
      <h3 className='text-center mt-5 mb-4'>Yard is your partner for property ownership.</h3> 
      <p className='text-center lead m-4'>If you are looking to get a new home loan, refinance or reduce your monthly payments, you can explore Yard’s home loan options.</p>
      <div className='card-body bottom text-center'>
        <a className='btn btn-xl btn-white mr-3 mb-5 apply-now-button' style={{ color: 'black!' }} href="/onboarding_funnel/new">
          <span className='black'>Apply now</span>
        </a>
        <span 
          className='btn btn-xl talk-to-expert-btn-grey-hover mr-3 mb-5 cta-talk-to-expert-button'
          onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
        >
          Talk to an expert
        </span>
      </div>
    </div>
  </div>
);

export default PartnersCTA
